import '../Loader.css';
import React from 'react';

const Loader = () => {
  return (
    <div className="loading-container">
      <div className="spinner"></div> 
    </div>
  );
};

export default Loader;